const initialState = {
  active: "none",
  activeSubmenu: "none",
  index: [],
  data: {},
};

const Menu = (state = initialState, action) => {
  switch (action.type) {
    case "CONTENT_MENU_ACTIVE":
      return { ...state, active: action.payload.active };
    case "CONTENT_MENU_ACTIVE_SUBMENU":
      return { ...state, activeSubmenu: action.payload.activeSubmenu };
    case "CONTENT_MENU_INDEX":
      return { ...state, index: action.payload.index };
    case "CONTENT_MENU_DATA":
      return { ...state, data: action.payload.data };
    case "CONTENT_MENU_RESET":
      return initialState;
    default:
      return state;
  }
};

export default Menu;
